import { render, staticRenderFns } from "./Tracking.ts.vue?vue&type=template&id=9a4e8216"
import script from "./Tracking.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tracking.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports